module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footern"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "left-float"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/huaweisverige/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/Honorglobal",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/huawei/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/HuaweiSverige",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.huawei.com"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/img/pbhlogo-min.png"),
      "width": "170"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-float"
  }, [_vm._v("\n      COPYRIGHT ©HUAWEI HONOR 1998-2017.\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cef4d348","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footern.vue
// module id = 234
// module chunks = 1